import Component from './message_status.vue'
export default Component
